/**
 * Listing Data Module
 *
 * BFF (Backend for Frontend) module for product listing pages.
 * Coordinates data fetching from CMS (Contentful) and search (Algolia).
 *
 * Usage:
 *   import { fetchListingPageData, type ListingPageData } from '@/lib/listingData';
 *   import { PLP_CONFIGS } from '@/lib/listingData';
 */

// Main orchestrator
// Helpers (for advanced use cases)
export {
  extractAlgoliaSettings,
  extractHeroFromContent,
  extractHeroSettings,
  extractSEOConfig,
  generateBreadcrumbs,
  isHeroProductListing,
} from './helpers';
// Re-export SEO types for convenience
export type { SeoVariables } from './helpers';
export { fetchListingPageData, getDefaultHeroSettings } from './orchestrator';
// PLP Configuration
export {
  filterFacetsByConfig,
  filterFacetsByPlpType,
  stripPriceFacet,
} from './filterFacetsByConfig';
export type { FilterFacetsOptions } from './filterFacetsByConfig';
export {
  buildMaterialFilter,
  formatCollectionName,
  getPLPConfig,
  getResolvedFacets,
  isValidPLPType,
  PLP_CONFIGS,
  resolveFacetAttribute,
  STANDARD_STRAP_LENGTH_FILTER,
  STRAP_MATERIAL_FILTERS,
} from './plpConfig';
export type { FacetConfig, FilterBarPosition, PLPConfig, PLPType } from './plpConfig';
// Types
export type {
  BreadcrumbItem,
  FetchListingPageOptions,
  HeroMedia,
  HeroSettings,
  ListingPageData,
  PaginationData,
  SEOConfig,
} from './types';
